export const MESSAGING_LOAD_MORE_CONVERSATIONS_REQUEST = 'MESSAGING:LOAD_MORE_CONVERSATIONS_REQUEST';
export const MESSAGING_LOAD_MORE_CONVERSATIONS_SUCCESS = 'MESSAGING:LOAD_MORE_CONVERSATIONS_SUCCESS';
export const MESSAGING_LOAD_MORE_CONVERSATIONS_FAILURE = 'MESSAGING:LOAD_MORE_CONVERSATIONS_FAILURE';

export const MESSAGING_NEW_CONV_REQUEST = 'MESSAGING:NEW_CONV_REQUEST';
export const MESSAGING_NEW_CONV_SUCCESS = 'MESSAGING:NEW_CONV_SUCCESS';
export const MESSAGING_NEW_CONV_FAILURE = 'MESSAGING:NEW_CONV_FAILURE';
